import { render, staticRenderFns } from "./CalendarConfig.vue?vue&type=template&id=1b14b6bc&scoped=true"
import script from "./CalendarConfig.vue?vue&type=script&lang=js"
export * from "./CalendarConfig.vue?vue&type=script&lang=js"
import style0 from "./CalendarConfig.vue?vue&type=style&index=0&id=1b14b6bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b14b6bc",
  null
  
)

export default component.exports